$(document).ready( function(){
    // if book-button on the page
	if ($('.book-button').length > 0){

        // on click of book-button open pop-up and insert data
        $('.book-button').click(function(evt){
            evt.preventDefault();
            // grab data from template
            var workshopID = $(this).attr('data-workshopid');
            var workshopName = $(this).attr('data-workshopname');
            var workshopDate = $(this).attr('data-workshopdate');

            // convert number to month
            function monthName(monthNum) {
                var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                return months[monthNum - 1];
            }
            // convert date from YYY-MM-DD to full
            function reformatDate(date) {
                var arr = date.split('-');
                return arr[2] + " " + monthName(arr[1]) + " " + arr[0];
            }

            // give the workshop id to the popup
            $('.workshop-form__background').addClass('workshop-form__background--visible ' + workshopID);

            // place the workshop name into the heading
            $('.workshop-name').text(workshopName);

            // place the date or dates into the heading
            if (($(this).attr('data-workshopdate2')) && ($(this).attr('data-workshopdate2') != workshopDate)) { // if there is a workshopdate2 and it is not the same as workshopdate
                var workshopDate2 = $(this).attr('data-workshopdate2');
                $('.workshop-date').text(reformatDate(workshopDate));
                $('.workshop-date2').text(' - ' + reformatDate(workshopDate2));
                $('input[name="WorkshopDate2"]').val(reformatDate(workshopDate2));
            } else if ($(this).attr('data-workshopdate')) {
                // just one date
                $('.workshop-date').text(reformatDate(workshopDate));
                $('.workshop-date2').text('');
                $('input[name="WorkshopDate2"]').val(reformatDate(workshopDate));
            } else {                
                // hide dates 
                $('.workshop-dates-wrapper').hide();
            }

            // set the workshop ID to it's hidden form field
            $('input[name="WorkshopID"]').val(workshopID);

            // set the workshop values to it's hidden form fields
            $('input[name="WorkshopName"]').val(workshopName);
            $('input[name="WorkshopDate"]').val(reformatDate(workshopDate));
        });

        // on click of close button pop-up will display none
        $('.workshop-form__close').click(function(evt) {
            evt.preventDefault();
            $('.workshop-form__background').removeClass('workshop-form__background--visible');
        });
    }
});